angular.module('tradersyard').controller('topic-create-ctrl', [
    '$scope',
    'graph-topic-factory',
    '$flex',
    function ($scope, $factory, $flex) {
        $scope.node = {};
        $scope.posts = [];
        $scope.$error = {};
        $scope.buffer = {};
        $scope.duration = 0;
        $scope.queue = 0;
        $scope.complete = false;

        angular.extend($scope, $flex.data);

        $scope.submit = function () {
            if ($scope.queue === 0) {
                $scope.queue = 1;
                $scope.create($scope.topic);
            }
        };

        $scope.create = function (data) {
            $factory
                .entry('forum', $scope.node.id)
                .create(data)
                .then(function (response) {
                    if (response.data.state === 0) {
                        $scope.complete = true;
                        $scope.topic = response.data.data;
                    } else {
                        $scope.queue = 0;
                    }
                });
        };

        $scope.goto = function () {
            window.location.replace('/topic/' + $scope.topic.id);
        };

        $scope.topic = {
            entry: 'forum',
            entry_id: $scope.node.id,
            name: '',
        };
    },
]);
